export default class CheckCodeImage {

  codeLength = 4;

  constructor() {
  }

  create() {
    let selfWidth = 90,
      selfHeight = 30,
      canvas = document.createElement('canvas'),
      ctx = canvas.getContext('2d'),
      temp = 'abcdefghjkmnpqrstuvwxyzABCDEFGHJKLMNPRSTUVWXYZ23456789'.split(''),
      vCode = '',
      color = 'rgb(' + this.randInt(1, 120) + ',' + this.randInt(1, 120) + ',' + this.randInt(1, 120) + ')';

    canvas.width = selfWidth;
    canvas.height = selfHeight;
    ctx.fillStyle = '#f3fbfe';
    ctx.fillRect(0, 0, selfWidth, selfHeight);
    ctx.globalAlpha = .8;
    ctx.font = '16px sans-serif';

    for (let _i = 0; _i < 10; _i++) {
      ctx.fillStyle = 'rgb(' + this.randInt(150, 225) + ',' + this.randInt(150, 225) + ',' + this.randInt(150, 225) + ')';
    }

    ctx.font = 'bold 32px sans-serif';
    for (let i = 0; i < this.codeLength; i++) {
      var temp_index = this.randInt(0, temp.length);
      ctx.fillStyle = color;
      ctx.fillText(temp[temp_index], 5 + i * 23, 25);
      ctx.transform(this.randFloat(0.85, 1.0), this.randFloat(-0.04, 0), this.randFloat(-0.3, 0.3), this.randFloat(0.85, 1.0), 0, 0);
      vCode += temp[temp_index];
    }

    ctx.beginPath();
    ctx.strokeStyle = color;
    const b = this.randFloat(selfHeight / 4, 3 * selfHeight / 4),
      f = this.randFloat(selfHeight / 4, 3 * selfHeight / 4),
      w = 2 * Math.PI / (this.randFloat(selfHeight * 1.5, selfWidth)),
      linePoint = (x) => {
        return this.randFloat(10, selfHeight / 2) * Math.sin(w * x + f) + b;
      };

    ctx.lineWidth = 5;
    for (let x = -20; x < 200; x += 4) {
      ctx.moveTo(x, linePoint(x));
      ctx.lineTo(x + 3, linePoint(x + 3));
    }
    ctx.closePath();
    ctx.stroke();

    return {
      code: vCode.toLowerCase(),
      dataURL: canvas.toDataURL()
    };
  }

  randFloat(start, end) {
    return start + Math.random() * (end - start);
  }

  randInt(start, end) {
    return Math.floor(Math.random() * (end - start)) + start;
  }
}